import { Button, Grid, Typography } from '@mui/material';
import { useMsal } from '@azure/msal-react';
import { loginRequest } from '../../AppSettings'
import { IPublicClientApplication } from '@azure/msal-browser';
import { useTheme } from '@mui/material/styles';

function handleLogin(instance: IPublicClientApplication) {
  instance.loginRedirect(loginRequest)
    .catch(e => {
      console.error(e);
    });
}

export const LoginPage = () => {
  const { instance } = useMsal();
  const theme = useTheme();

  return (
    <Grid container direction='column' alignItems='center' justifyContent='center' style={{ minHeight: `calc(100vh - ${theme.mixins.toolbar.minHeight}px - 50px)` }}>
      <Typography variant='h4' style={{ marginBottom: '1em' }}>Logowanie</Typography>
      <Typography style={{ marginBottom: '2em' }}>Aby przeglądać zawartość musisz być zalogowany za pomoca konta firmowego.</Typography>
      <Button size='large' variant='outlined' color='primary' style={{ padding: '20px' }} onClick={() => handleLogin(instance)}>
        <img alt='MS logo' src='icons/Microsoft_logo.svg' style={{width: '30px', marginRight: '10px'}} />
        Zaloguj się za pomocą konta microsoft
      </Button>
    </Grid>
  );
}